import React, { useEffect, useState } from "react";
import Spinner from "../../../components/common/Spinner/Spinner";
import AssetTabs from "../AssetTabs";
import Separation from "../../common/SeparationLine/Separation";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../AssetStatusForm.scss'
import LoaderOverlay from "../../common/Loader/LoaderOverlay";
import SmallSeparationLine from "../../common/SeparationLine/SmallSeparation";
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AlarmsModal from "../../common/AlarmsModal/AlarmModal";
import ConfirmationModal from "../../common/Modal/ConfirmationModal";


const statusScreenPanelintialValue = {
    "last": { "value": "", "unit": "" },
    "state": { "value": "", "unit": "" },
    "timeInState": { "value": "", "unit": "" },
    "reason": { "value": "", "unit": "" },
    "closeTrigger": { "value": "", "unit": "" },
    "openTrigger": { "value": "", "unit": "" },
    "lastFall": { "value": "", "unit": "" },
    "lastArrVelocity": { "value": "", "unit": "" },
    "lastArrTime": { "value": "", "unit": "" },
    "lastSlugVol": { "value": "", "unit": "" },
    "alarms": "",
    "tubing": { "value": "", "unit": "" },
    "casing": { "value": "", "unit": "" },
    "line": { "value": "", "unit": "" },
    "gasRate": { "value": "", "unit": "" },
    "battery": { "value": "", "unit": "" },
    "solar": { "value": "", "unit": "" },
    "version": { "value": "", "unit": "" },
    "aux1": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "aux2": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "aux3": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "mode": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "pfc1": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "pfc2": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "todaysOpens": { "value": "", "unit": "" },
    "todaysArrivals": { "value": "", "unit": "" },
    "hexcode": "",
    "todaysAvgArrival": { "value": "", "unit": "" },
    "totalArrival": { "value": "", "unit": "" },
    "ccid": { "value": "", "unit": "" },
    "unit": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "loadFactor": { "value": "", "unit": "" },
    "yesterdayOpens": { "value": "", "unit": "" },
    "yesterdayArrivals": { "value": "", "unit": "" },
    "yesterdaysAvgArrival": { "value": "", "unit": "" },
    "plungerTravelDistance": { "value": "", "unit": "" },
    "signalStrength": { "value": "", "unit": "" },
    "activeCarrier": { "value": "", "unit": "" },
    "powerManagementScheme": { "value": "", "unit": "" },
    "powerMode": { "value": "", "hexCode": "", "unit": "" },
    "catchEnabled": "",
    "releaseEnabled": "",
    "openHoldEnabled": "",
    "closeHoldEnabled": "",
    "wellMethod": { "value": "", "text": "" }

    // "todayAvgArrivalVelocity": { "value": "", "unit": "" }
}


type WellStatusDetails = typeof statusScreenPanelintialValue & {
    todayAvgArrivalVelocity?: {
        value: number | null;
        unit: string | null;
    };
};

type FieldState = {
    [key: string]: string;
};

type SetpointRegisterPayload = {
    Id: number;
    value: string;
    comment?: string;
};

type SaveSetpointsPayload = {
    registers: SetpointRegisterPayload[];
    assetId: string;
    assetName: string;
};

interface AssetTabsProps {
    assetName: string,
    assetId: string,
    customerId: string,
    userTimeZone: string,
    handleLogout: () => void,
    setWellVersion: React.Dispatch<React.SetStateAction<string>>,
    setAuxProperties: React.Dispatch<React.SetStateAction<{
        aux1: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        aux2: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        aux3: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        mode: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        pfc1: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        pfc2: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        unit: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        }
    }>>
    setisIntermittentMode: React.Dispatch<React.SetStateAction<boolean>>
    setIsBasicWellMethod: React.Dispatch<React.SetStateAction<boolean>>
}




const AssetStatusForm: React.FC<AssetTabsProps> = ({ assetName, assetId, customerId, userTimeZone, handleLogout, setWellVersion, setAuxProperties, setisIntermittentMode, setIsBasicWellMethod }) => {
    const [tabDivHeight, setTabDivHeight] = useState("640px")
    const [wellStatusDetails, setWellStatusDetailsData] = useState<WellStatusDetails>(statusScreenPanelintialValue);
    const [loading, setLoading] = useState(false);
    const [isSetPointloading, setIsSetPointloading] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false)
    const [isValveControlUser, setIsValveControlUser] = useState(false)
    const [initialFormState, setIntialFormState] = useState({} as { [key: string]: FieldState })
    const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
    const [statusScreenHeight, setStatusScreenHeight] = useState("960px")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isValveModalOpen, setIsValveModalOpen] = useState(false);
    const [isOpenValveClick, setIsOpenValveClick] = useState("");
    const [isMode, setIsMode] = useState("")
    const [isLatestVersion, setLatestVersion] = useState(false)

    const queryParams = {
        // Add your query parameters here
        wellId: assetId,
        customerId: customerId,
        timeZoneId: userTimeZone
    };

    const queryParamsConfig = {
        // Add your query parameters here
        wellId: assetId,
    };

    // Convert the query parameters to a string
    const queryString = new URLSearchParams(queryParams).toString();
    const queryStringForConfiguration = new URLSearchParams(queryParamsConfig).toString();
    const apiUrl = `${baseUrl}/Wells/GetAllStatusData?${queryString}`;
    const postApiUrl = `${baseUrl}/SetPointsAggregation/AddSetPointsDataByAssetId`;
    const getSetPointConfiguration = `${baseUrl}/SetPointsAggregation/GetAllSetPointsMasterByWellID?${queryStringForConfiguration}`;
    const [isExpanded, setIsExpanded] = useState(true);
    const { aux1, aux2, aux3, mode, unit, pfc1, pfc2 } = wellStatusDetails;
    const alarms = wellStatusDetails?.alarms ?? "";

    const alarmList = alarms
        .split(",")
        .map(a => a.trim())
        .filter(Boolean);

    const showClearAlarmsButton =
        alarmList.length > 0 &&
        alarmList.some(a => a.toUpperCase() !== "OK") &&
        isVersionGreaterOrEqual(
            wellStatusDetails?.version?.value ?? "",
            "2.1.42"
        );

    useEffect(() => {
        const properties = [aux1, aux2, aux3, mode, unit, pfc1, pfc2].filter(prop => prop && prop?.index !== "");
        setAuxProperties({
            aux1: properties[0] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            aux2: properties[1] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            aux3: properties[2] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            mode: properties[3] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            unit: properties[4] || { label: 'Disabled', index: '1', value: 'imperial', checked: false, unit: "" },
            pfc1: properties[5] || { label: 'Disabled', index: '0', value: '', checked: false, unit: "" },
            pfc2: properties[6] || { label: 'Disabled', index: '0', value: '', checked: false, unit: "" }
        });
    }, [aux1, aux2, aux3, mode, unit, pfc1, pfc2]);

    const renderProperties = () => {
        const staticProperty = [
            { label: "Tubing", value: wellStatusDetails?.tubing?.value, index: "1", hexCode: "", unit: wellStatusDetails?.tubing?.unit },
            { label: "Casing", value: wellStatusDetails?.casing?.value, index: "1", hexCode: "", unit: wellStatusDetails?.casing?.unit },
            { label: "Line", value: wellStatusDetails?.line?.value, index: "1", hexCode: "", unit: wellStatusDetails?.line?.unit },
            { label: "Load factor", value: wellStatusDetails?.loadFactor?.value, index: "1", hexCode: "", unit: wellStatusDetails?.loadFactor?.unit },
            { label: "Gas Rate  ", value: wellStatusDetails?.gasRate?.value, index: "1", hexCode: "", unit: wellStatusDetails?.gasRate?.unit },
            { label: "Battery", value: wellStatusDetails?.battery?.value, index: "1", hexCode: "", unit: wellStatusDetails?.battery?.unit },
            { label: "Solar", value: wellStatusDetails?.solar?.value, index: "1", hexCode: "", unit: wellStatusDetails?.solar?.unit }
        ];

        const lastProperty = [
            { label: "Power Mgmt", value: wellStatusDetails?.powerManagementScheme?.value, index: "1", hexCode: "", unit: wellStatusDetails?.powerManagementScheme?.unit },
            { label: "Power Mode", value: wellStatusDetails?.powerMode?.value, index: "1", hexCode: wellStatusDetails?.powerMode?.hexCode, unit: wellStatusDetails?.powerMode?.unit },
            { label: "Signal Strength", value: wellStatusDetails?.signalStrength?.value, index: "1", hexCode: "", unit: wellStatusDetails?.signalStrength?.unit },
            { label: "Carrier", value: wellStatusDetails?.activeCarrier?.value, index: "1", hexCode: "", unit: wellStatusDetails?.activeCarrier?.unit },
            { label: "Version", value: wellStatusDetails?.version?.value, index: "1", hexCode: "", unit: wellStatusDetails?.version?.unit }
        ]

        const properties = [
            ...staticProperty,
            mode,
            aux1,
            aux2,
            aux3,
            pfc1,
            pfc2,
            ...lastProperty
        ].filter((prop) => prop && prop?.index !== "0" && prop?.index !== "");


        return properties.map((prop, i) => (
            <div key={i} className="w-full" style={{ paddingRight: "20px" }}>
                <div className="ml-3 mt-2 mb-2">
                    <p className="flex justify-between text-md">
                        {`${prop?.label}:`}
                        <label
                            className="label text-md ml-auto flex items-center"
                            style={{
                                color: prop?.hexCode,
                                border: prop?.hexCode ? `1px solid ${prop?.hexCode}` : "none",
                                padding: prop?.hexCode ? "1px 4px" : undefined,
                            }}
                        >
                            {prop?.value}
                            {prop?.unit && (
                                <span style={{ color: "var(--Primary-Indigo-500, #0094BD)", marginLeft: "12px" }}>
                                    | {prop.unit}
                                </span>
                            )}
                        </label>
                    </p>
                </div>
            </div>
        ));

    };

    const getValveActionMessage = (valveAction: string): string => {
        switch (valveAction) {
            case "OpenValve":
                return "Confirm Valve Open?";
            case "OpenHold":
                return "Confirm Hold Open?";
            case "Catch":
                return "Confirm Catch?";
            case "CloseValve":
                return "Confirm Valve Close?";
            case "CloseHold":
                return "Confirm Hold Close?";
            case "Release":
                return "Confirm Release?";
            case "Alarms":
                return "Clear Active Alarms?";
            default:
                return "";
        }
    };



    // Function to open the modal
    const openModal = () => {
        setIsModalOpen(true);
    };
    // Function to determine the color based on severity
    const getSeverityColor = (severity) => {
        switch (severity?.toString()) {
            case "critical":
                return "1px solid var(--Error-Red-700, #B42318)"; // Red border for critical
            case "high":
                return "1px solid var(--Colors-Red, #FF3B30)"; // Orange border for high
            case "medium":
                return "1px solid var(--Secondary-Orange-400, #FB743C)"; // Yellow border for medium
            case "low":
                return "1px solid var(--Warning-Yellow-400, #FDB022)"; // Green border for low
            default:
                return "border-gray-500"; // Default gray for unknown
        }
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Function for Cancel button
    const handleCancel = () => {
        closeModal(); // Close modal when cancel is clicked
    };


    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const isEmptyObject = (obj) => {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    };
    // Function to display toast message
    const sucessShowToast = () => {
        toast.success('Device command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }

    // Function to display toast message
    const errorShowToast = () => {
        toast.error('Device command failed!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "red", // Set your desired text color for error messages
                background: "#f8d7da", // Set your desired background color for error messages
            }
        });
    }


    const saveSetpointsData = async (queryParams) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // specify content type as JSON if sending JSON data
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`
                // You may need to include additional headers based on your API requirements
            },
            body: JSON.stringify(queryParams) // convert data to JSON string
        };
        try {
            const response = await fetch(postApiUrl, requestOptions);
            if (response.status === 401) {
                handleLogout()
            }
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            setIsSetPointloading(false);
            const data = await response?.json();

            if (data === false) {
                setTimeout(errorShowToast, 1000)
            }
            else {
                setTimeout(sucessShowToast, 1000)

            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    function isVersionGreaterOrEqual(v1: string, v2: string): boolean {
        const toNumbers = (v: string) => v.split(".").map(Number);
        const [a1, b1, c1] = toNumbers(v1);
        const [a2, b2, c2] = toNumbers(v2);

        if (a1 !== a2) return a1 > a2;
        if (b1 !== b2) return b1 > b2;
        return c1 >= c2;
    }


    useEffect(() => {
        const fetchData = async (isFirstTime = false) => {
            const headers = {
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                'Content-Type': 'application/json' // Adjust content type if needed
            };
            try {
                const response = await fetch(apiUrl, { headers });
                if (response.status === 401) {
                    handleLogout();
                }
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setWellStatusDetailsData(data);
                setWellVersion(data?.version);
                setisIntermittentMode(data?.intermittentMode)
                setIsBasicWellMethod(data?.wellMethod?.value === 1 ? true : false)
                if (isVersionGreaterOrEqual(data?.version?.value ?? "0.0.0", "2.1.32")) {
                    setLatestVersion(true);
                } else {
                    setLatestVersion(false);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                if (isFirstTime) {
                    setLoading(false); // Set loading to false whether the fetch was successful or not
                }
            }
        };

        const fetchSetPointsConfiguration = async () => {
            setLoading(true)
            const headers = {
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                'Content-Type': 'application/json' // Adjust content type if needed
            };
            try {
                const responseConfiguration = await fetch(getSetPointConfiguration, { headers });
                if (responseConfiguration.status === 401) {
                    handleLogout();
                }
                if (!responseConfiguration.ok) {
                    throw new Error('Network response was not ok');
                }
                const configurationData = await responseConfiguration.json();

                setIntialFormState(configurationData.setpoints);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const initialize = async () => {
            setLoading(true);
            setIsReadOnly(Boolean(localStorage.getItem("jwtUserReadOnly") === "false" ? false : true));
            setIsValveControlUser(Boolean(localStorage.getItem("jwtIsValveControlUser") === "false" ? false : true));
            await fetchSetPointsConfiguration();
            await fetchData(true);
        };

        initialize();

        // Schedule fetchData to run every 5 seconds (5000 milliseconds)
        const intervalId = setInterval(fetchData, 5000);

        // Clean up the interval to avoid memory leaks
        return () => clearInterval(intervalId);
    }, [assetId]);

    const handleValveActionClick = async (action: string, comment?: string) => {
        setIsSetPointloading(true);
        const registerMap: Record<string, number> = {
            OpenValve: 43,
            OpenHold: 202,
            CloseValve: 44,
            CloseHold: 203,
            Catch: 220,
            Release: 221,
            Alarms: 50
        };

        const postBody: SaveSetpointsPayload = {
            registers: [{
                Id: registerMap[action],
                value: action === "Alarms" ? "8" : "1",
                ...(typeof comment === "string" && (action === "OpenHold" || action === "CloseHold")
                    ? { comment }
                    : {}),
            }],
            assetId,
            assetName,
        };

        await saveSetpointsData(postBody);
    };



    const handleOpenValveClick = async () => {
        setIsSetPointloading(true)
        const postBody = { registers: [{ Id: 43, value: "1" }], assetId, assetName }
        await saveSetpointsData(postBody)

    }

    const handleCloseValveClsick = async () => {
        setIsSetPointloading(true)
        const postBody = { registers: [{ Id: 44, value: "1" }], assetId, assetName }
        await saveSetpointsData(postBody)
    }

    const hasTodayAvgArrivalVelocity =
        Object.prototype.hasOwnProperty.call(
            wellStatusDetails,
            "todayAvgArrivalVelocity"
        );


    return (
        <div className="bg-darkcolor-800 content-wrapper mt-5">
            {loading && isEmptyObject(initialFormState) && <LoaderOverlay />} {/* Render LoaderOverlay only when loading state is true */}
            <ToastContainer />
            <div
                onClick={toggleExpand}
                style={{ backgroundColor: "#4A5463", marginLeft: "15px", marginRight: "15px" }}
                className="mx-auto pl-[15px] pr-[15px] flex items-center cursor-pointer p-2"
            >
                <div
                    style={{
                        backgroundColor: "var(--Primary-Indigo-400, #60BFDA)",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "22px",
                        height: "20px",
                        borderRadius: "10%"
                    }}
                    className="p-2"
                >
                    <FontAwesomeIcon icon={isExpanded ? faMinus : faPlus} />
                </div>
                <span
                    style={{ color: "var(--Primary-Indigo-400, #60BFDA)", marginLeft: "5px" }}
                >
                    Status
                </span>
            </div>

            {isExpanded &&
                <div className="border border-darkcolor-500 ml-[15px] mr-[15px] pb-[15px]" style={{ borderTop: 'none', borderRadius: '0 0 8px 8px' }}>
                    <div className="w-full flex bg-darkcolor-800 px-[15px] gap-4" >
                        {/* LEFT SIDE - 1/3 */}
                        <div className="w-1/3 flex flex-col gap-4" style={{ marginTop: "15px" }}>

                            {/* Controls */}
                            {!isReadOnly && !loading && <div className="border border-darkcolor-500 bg-darkcolor-600 rounded-lg py-4">
                                <span className="mb-3 pl-5 pt-1 block text-white">Controls</span>
                                <Separation />

                                <div className="pt-4">
                                    <div className="flex flex-wrap justify-center" style={{ gap: "1.5rem" }}>
                                        {!isReadOnly && <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base ${isSetPointloading ? 'disabled-button' : ''}`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                visibility: isReadOnly ? "hidden" : "visible", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("OpenValve");
                                            }}
                                            disabled={isSetPointloading}
                                        >
                                            Open Valve
                                        </button>
                                        }
                                        <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base font-medium ${(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.openHoldEnabled))
                                                ? 'disabled-button'
                                                : ''
                                                }`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                visibility: Boolean(wellStatusDetails?.openHoldEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("OpenHold");
                                            }}
                                            disabled={(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.openHoldEnabled))}
                                        >
                                            Hold Open
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base font-medium ${(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.catchEnabled)) ? 'disabled-button' : ''}`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                paddingLeft: "25px",
                                                visibility: Boolean(wellStatusDetails?.catchEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("Catch");
                                            }}
                                            disabled={(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.catchEnabled))}
                                        >
                                            Catch
                                        </button>
                                    </div>

                                    <div className="flex flex-wrap gap-2 justify-center mt-4" style={{ gap: "1.5rem" }}>
                                        {!isReadOnly && <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base font-medium ${isSetPointloading ? 'disabled-button' : ''}`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                visibility: isReadOnly ? "hidden" : "visible", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("CloseValve");
                                            }}
                                            disabled={isSetPointloading}
                                        >
                                            Close Valve
                                        </button>
                                        }
                                        <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base font-medium ${(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.closeHoldEnabled)) ? 'disabled-button' : ''}`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                visibility: Boolean(wellStatusDetails?.closeHoldEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("CloseHold");
                                            }}
                                            disabled={(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.closeHoldEnabled))}
                                        >
                                            Hold Close
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn btn-primary text-center text-base font-medium ${(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.releaseEnabled)) ? 'disabled-button' : ''}`}
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                                width: "120px",
                                                paddingLeft: "25px",
                                                visibility: Boolean(wellStatusDetails?.releaseEnabled) || isValveControlUser ? "visible" : "hidden", // Ensures alignment
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("Release");
                                            }}
                                            disabled={(!isValveControlUser && isSetPointloading) ||
                                                (isSetPointloading && !Boolean(wellStatusDetails?.releaseEnabled))}
                                        >
                                            Release
                                        </button>
                                    </div>
                                </div>

                            </div>
                            }


                            {/* Status */}
                            <div className="border border-darkcolor-500 bg-darkcolor-600 rounded-lg py-4" style={{ height: statusScreenHeight }}>
                                <div className="mb-5 mr-2">
                                    <span className="ml-3">Status</span>
                                </div>
                                <Separation />
                                {/* Status Properties */}
                                <div className="flex flex-wrap">
                                    {[
                                        {
                                            label: "Last:",
                                            value: wellStatusDetails?.last?.value,
                                            color: wellStatusDetails?.hexcode,
                                            unit: wellStatusDetails?.last?.unit

                                        },
                                        { label: "State:", value: wellStatusDetails?.state?.value, unit: wellStatusDetails?.state?.unit },
                                        { label: "Time in State:", value: wellStatusDetails?.timeInState?.value, unit: wellStatusDetails?.timeInState?.unit },
                                        { label: "Reason:", value: wellStatusDetails?.reason?.value, unit: wellStatusDetails?.reason?.unit },
                                        { label: "Open Trigger:", value: wellStatusDetails?.openTrigger?.value, unit: wellStatusDetails?.openTrigger?.unit },
                                        { label: "Close Trigger:", value: wellStatusDetails?.closeTrigger?.value, unit: wellStatusDetails?.closeTrigger?.unit },
                                        { label: "Last Fall:", value: wellStatusDetails?.lastFall?.value, unit: wellStatusDetails?.lastFall?.unit },
                                        { label: "Last Slug Vol:", value: wellStatusDetails?.lastSlugVol?.value, unit: wellStatusDetails?.lastSlugVol?.unit },
                                        { label: "Last Arr Velocity:", value: wellStatusDetails?.lastArrVelocity?.value, unit: wellStatusDetails?.lastArrVelocity?.unit },
                                        { label: "Last Arr Time:", value: wellStatusDetails?.lastArrTime?.value, unit: wellStatusDetails?.lastArrTime?.unit },
                                        { label: "Today's Opens:", value: wellStatusDetails?.todaysOpens?.value, unit: wellStatusDetails?.todaysOpens?.unit },
                                        { label: "Today's Arrivals:", value: wellStatusDetails?.todaysArrivals?.value, unit: wellStatusDetails?.todaysArrivals?.unit },
                                        { label: "Today's Avg Arrival:", value: wellStatusDetails?.todaysAvgArrival?.value, unit: wellStatusDetails?.todaysAvgArrival?.unit },
                                        ...(hasTodayAvgArrivalVelocity
                                            ? [{
                                                label: "Today's Avg Arrival Velocity:",
                                                value: wellStatusDetails?.todayAvgArrivalVelocity?.value,
                                                unit: wellStatusDetails?.todayAvgArrivalVelocity?.unit
                                            }]
                                            : []),
                                        { label: "Yesterday's Opens:", value: wellStatusDetails?.yesterdayOpens?.value, unit: wellStatusDetails?.yesterdayOpens?.unit },
                                        { label: "Yesterday's Arrivals:", value: wellStatusDetails?.yesterdayArrivals?.value, unit: wellStatusDetails?.yesterdayArrivals?.unit },
                                        { label: "Yesterday's Avg Arrival:", value: wellStatusDetails?.yesterdaysAvgArrival?.value, unit: wellStatusDetails?.yesterdaysAvgArrival?.unit },
                                        { label: "User Total Arrivals:", value: wellStatusDetails?.totalArrival?.value, unit: wellStatusDetails?.totalArrival?.unit },
                                        { label: "Plunger Travel Distance:", value: wellStatusDetails?.plungerTravelDistance?.value, unit: wellStatusDetails?.plungerTravelDistance?.unit }

                                    ].map((item, index, arr) => (
                                        <React.Fragment key={index}>
                                            <div className="flex w-full">
                                                <div className="flex w-[50%]">
                                                    <div className="ml-3 mt-2 mb-2 flex w-full">
                                                        <p className="flex justify-between text-md w-full">
                                                            {item.label}
                                                            <label
                                                                className="label text-md text-right ml-auto flex items-center"
                                                                style={{ color: item.color }}
                                                            >
                                                                {item.value}
                                                                {item.unit && (
                                                                    <span style={{ color: "var(--Primary-Indigo-500, #0094BD)", marginLeft: "12px" }}>
                                                                        | {item.unit}
                                                                    </span>
                                                                )}
                                                            </label>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex w-[50%]">
                                                    {index < renderProperties().length && renderProperties()[index]}
                                                </div>
                                            </div>
                                            {index < arr.length - 1 && <div className="w-full"><Separation /></div>}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>

                            {/* Alarms */}
                            <div className="border border-darkcolor-500 bg-darkcolor-600 rounded-lg py-4" style={{ height: isReadOnly ? "330px" : isMode === "4" ? "320px" : "164px" }}>
                                <div className="flex items-center justify-between mb-3 pt-3">
                                    <span className="pl-5">Alarms</span>

                                    {showClearAlarmsButton && (
                                        <button
                                            type="button"
                                            className="btn btn-primary text-center text-base font-medium mr-5"
                                            style={{
                                                backgroundColor: "var(--Primary-Indigo-700, #005F7C)",
                                            }}
                                            onClick={() => {
                                                setIsValveModalOpen(true);
                                                setIsOpenValveClick("Alarms");
                                            }}
                                        >
                                            Clear Alarms
                                        </button>
                                    )}
                                </div>
                                <Separation />
                                <div className="pl-5 mt-2" style={{ color: wellStatusDetails.alarms === "OK" ? "green" : "red" }}>
                                    {wellStatusDetails?.alarms?.split(',')?.map((alarm, index) => (
                                        <button key={index} style={{ marginRight: '5px', marginBottom: '5px', border: alarm === "OK" ? '1px solid green' : '1px solid red', borderRadius: '5px', padding: '5px', fontSize: '12px' }}>
                                            {alarm}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE - 2/3 */}
                        <div className="w-2/3 border border-darkcolor-500 bg-darkcolor-600 p-4 rounded-lg" style={{ height: tabDivHeight, marginTop: "15px" }}>
                            {!isEmptyObject(initialFormState) && (
                                <AssetTabs
                                    initialFormState={initialFormState}
                                    setTabDivHeight={setTabDivHeight}
                                    assetId={assetId}
                                    assetName={assetName}
                                    isReadOnly={isReadOnly}
                                    isSetPointLoading={isSetPointloading}
                                    setIsSetPointLoading={setIsSetPointloading}
                                    handleLogout={handleLogout}
                                    userTimeZone={userTimeZone}
                                    setIsMode={setIsMode}
                                    isLatestVersion={isLatestVersion}
                                    isValveControlUser={isValveControlUser}
                                />
                            )}
                        </div>
                    </div>

                </div>
            }
            <AlarmsModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={`Alarms configuration - ${assetName}`}
                onCancel={handleCancel}
            />
            <ConfirmationModal
                isOpen={isValveModalOpen}
                message={getValveActionMessage(isOpenValveClick)}
                setIsValveModalOpen={() => setIsValveModalOpen(false)}
                showCommentBox={isOpenValveClick === "OpenHold" || isOpenValveClick === "CloseHold"}
                handleOpenValveClick={(comment?: string) => handleValveActionClick(isOpenValveClick, comment)}


            />
            <div className={isExpanded ? "mb-[15px]" : "mb-[15px]"} />
        </div>
    );
};

export default AssetStatusForm;
